import { type FC } from 'react'

import { productAccessorGetBestSellerPromotionFromOffer } from '../../../../product'
import { useProductPageContext } from '../../productPageContext'

import { ProductBuyBoxVoucherInfoProduct } from './ProductBuyBoxVoucherInfoProduct'
import { ProductBuyBoxVoucherInfoSeller } from './ProductBuyBoxVoucherInfoSeller'

export const ProductBuyBoxVoucherInfo: FC = () => {
  const { currentOffer, product } = useProductPageContext()

  if (productAccessorGetBestSellerPromotionFromOffer(currentOffer)) {
    return <ProductBuyBoxVoucherInfoSeller />
  }

  if (!product.voucher_code) {
    return null
  }

  return <ProductBuyBoxVoucherInfoProduct />
}
